module.exports = __webpack_public_path__ + "static/media/favorite.9e473913.svg";